import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { MiscApi, RequestStrategyEnum, type WithSignal } from '@shared/api';

const getTransferCurrenciesEffect = createEffect(({ signal }: WithSignal = {}) => MiscApi.getTransferCurrencies(signal));
const clearEvent = createEvent();

const $dataStore = createStore<string[]>([])
  .on(getTransferCurrenciesEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getTransferCurrenciesEffect.pending, (_, data) => data)
  .on(getTransferCurrenciesEffect.fail, () => false)
  .on(getTransferCurrenciesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getTransferCurrenciesEffect, () => null)
  // .on(getTransferCurrenciesEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getTransferCurrenciesEffect.fail, () => 'Something went wrong while fetching Transfer Currencies. Please try again.')
  .on(getTransferCurrenciesEffect.done, () => null)
  .reset(clearEvent);

export const $transferCurrenciesStore = {
  events: {
    getTransferCurrencies: ApiUtils.wrapperApi(getTransferCurrenciesEffect, RequestStrategyEnum.Debounce).trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
